import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=fd608530&scoped=true&"
import script from "./BaseLink.vue?vue&type=script&lang=js&"
export * from "./BaseLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=fd608530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd608530",
  null
  
)

export default component.exports